<template>
    <i class="fas" :class="classes" />
</template>

<script>
const Timeliness = {
    AHEAD: 'AHEAD',
    BEHIND: 'BEHIND',
    ON_TIME: 'ON_TIME',
}
export default {
    name: 'PunctualityIcon',
    props: {
        timeliness: String,
        deviationSeconds: Number,
    },
    computed: {
        ahead() {
            const { timeliness } = this.$props
            return timeliness === Timeliness.AHEAD
        },
        behind() {
            const { timeliness } = this.$props
            return timeliness === Timeliness.BEHIND
        },
        ontime() {
            const { timeliness } = this.$props
            return timeliness === Timeliness.ON_TIME
        },
        isEarly() {
            const { deviationSeconds, timeliness } = this.$props
            if (timeliness === Timeliness.AHEAD) {
                return true
            }
            if (timeliness === Timeliness.BEHIND) {
                return false
            }
            return deviationSeconds < -60
        },
        isLate() {
            const { deviationSeconds, timeliness } = this.$props
            if (timeliness === Timeliness.AHEAD) {
                return false
            }
            if (timeliness === Timeliness.BEHIND) {
                return true
            }
            return deviationSeconds > 60
        },
        alot() {
            const threshold = 30 * 60
            const { deviationSeconds } = this.$props
            return (
                (deviationSeconds > 0 && deviationSeconds > threshold) ||
                (deviationSeconds < 0 && deviationSeconds < 0 - threshold)
            )
        },
        classes() {
            return {
                'fa-angle-up': this.isEarly && !this.alot,
                'fa-angle-double-up': this.isEarly && this.alot,
                'fa-angle-down': this.isLate && !this.alot,
                'fa-angle-double-down': this.isLate && this.alot,
                ahead: this.ahead,
                behind: this.behind,
                ontime: this.ontime,
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';

.ahead {
    color: $success;
}

.behind {
    color: $danger;
}

.ontime {
    color: #add8e6;
}
</style>
